<ids-form-field
  [label]="label"
  [description]="description"
  [errorMessage]="errorMessage"
  [formGroup]="formParent"
>
  <ids-select [formControlName]="formControlName" (change)="changeDomain()">
    <ids-option *ngFor="let item of domainResponse" [value]="item.name">
      {{ item.name | titlecase }}
    </ids-option>
  </ids-select>
</ids-form-field>
